import { createAction } from "redux-actions";
import {
  UPDATE_RESUME_FORM_FAILURE,
  UPDATE_RESUME_FORM_SUCCESS,
  SET_SELECTED_TEMPLATE_SUCCESS,
  SET_SELECTED_TEMPLATE_FAILURE,
} from "../constants/actionTypes";

const updateResumeFormSuccess = createAction(UPDATE_RESUME_FORM_SUCCESS);
const updateResumeFormFailure = createAction(UPDATE_RESUME_FORM_FAILURE);

export function updateResumeForm(data) {
  return (dispatch) => {
    try {
      dispatch(updateResumeFormSuccess({ data }));
    } catch (error) {
      dispatch(updateResumeFormFailure(error));
    }
  };
}

const setSelectedTemplateSuccess = createAction(SET_SELECTED_TEMPLATE_SUCCESS);
const setSelectedTemplateFailure = createAction(SET_SELECTED_TEMPLATE_FAILURE);

export function setSelectedTemplate(template) {
  return (dispatch) => {
    console.log('template aaaa', template);
    try {
      dispatch(setSelectedTemplateSuccess({ data:template }));
    } catch (error) {
      dispatch(setSelectedTemplateFailure(error));
    }
  };
}

